import { Routes } from '@angular/router';
import { LoginPageComponent } from '../pages/login/login.component';
import { RecoverPasswordPageComponent } from '../pages/recover-password/recover-password.component';

export const AUTH_ROUTES: Routes = [
    { path: 'login', component: LoginPageComponent },
    { path: 'recover-password', component: RecoverPasswordPageComponent },
];
